import React, { memo, useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocalStorage } from "react-use";
import { parse } from "query-string";
import { actions } from "rdx";

type PropsT = {
  authUri: string | URL | undefined;
  children?: React.ReactNode;
  redirectPath?: string;
  onBeforeRedirect?: () => void;
};

const retainAlr = (setAlr) => {
  const search = parse(window.location.search);
  if (search.alr) {
    setAlr(search.alr.toString());
  }
};

const LoginSocialGoogle = ({ children, authUri, redirectPath, onBeforeRedirect }: PropsT) => {
  const [, setAlr] = useLocalStorage("alr", null);
  const dispatch = useDispatch();
  const loginGoogle = useCallback(() => {
    onBeforeRedirect?.();
    retainAlr(setAlr);
    dispatch(actions.oauth(redirectPath ? { redirectPath } : undefined));
  }, [dispatch, setAlr, redirectPath, onBeforeRedirect]);

  useEffect(() => {
    if (!authUri) return;
    window.open(authUri, "_self");
  }, [authUri]);

  return (
    <div role="button" tabIndex={0} onKeyDown={loginGoogle} onClick={loginGoogle}>
      {children}
    </div>
  );
};

export default memo(LoginSocialGoogle);
